/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ GlobalDrawer)
/* harmony export */ });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({ key: 'component-drawer' });
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => {
      element.addEventListener('click', this.closeDrawer);
    });

    if (window.Shopify.designMode) {
      window.addEventListener('resize', this.handleResize);
    }
  }

  openDrawer() {
    window.eventBus.emit('close:all:drawers', this);
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open');
    this.addEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:opened', this);
  }

  closeDrawer() {
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open');
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:closed', this);
  }

  closeAllDrawers(e) {
    if (e === this) return;
    this.closeDrawer();
  }

  handleTransitionEnd(e) {
    if (e.target === this) {
      this.trapFocus();
    }
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    firstFocusableElement.focus();
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  handleResize() {
    this.classList.add('disable-transitions');
    setTimeout(() => {
      this.classList.remove('disable-transitions');
    }, 500);
  }

  disconnectedCallback() {
    if (window.Shopify.designMode) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	function __webpack_require__(moduleId) {
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	(() => {
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);


class SizeGuideDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A {
  constructor() {
    super();
    // Ian - Targets the size guide drawer title by class instead of heading tag so the drawer title can use body text markup.
    this.pageTitleContainer = this.querySelector('[data-size-guide-dynamic-content="size-guide-header"] .size-guide-drawer__heading');
    this.pageContentContainer = this.querySelector('[data-size-guide-content]');
    this.loadPageContent = this.loadPageContent.bind(this);
    this.loadMetafieldContent = this.loadMetafieldContent.bind(this);
    this.init = this.init.bind(this);
    this.sectionId = this.getAttribute('data-section-id');
  }

  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({ key: 'component-size-guide-drawer' });

    window.eventBus.on('open:size:guide', this.init);
    window.eventBus.on('close:size:guide', this.closeDrawer);
  }

  init(event) {
    if (event && event.url) {
      if (event.url.includes('#size-guide-metafield-drawer')) {
        this.loadMetafieldContent();
      } else {
        this.loadPageContent(event.url);
      }
    }

    this.openDrawer();
    this.handleEditorEvents();
  }

  loadMetafieldContent() {
    try {
      if (this.pageContentContainer) {
        this.pageContentContainer.innerHTML = '';
      }

      if (this.pageTitleContainer) {
        this.pageTitleContainer.textContent = 'Size guide';
      }

      const template = document.querySelector('[id^="ProductSizeGuideHTML-"]');

      if (template && this.pageContentContainer) {
        this.pageContentContainer.innerHTML = template.innerHTML;
      } else {
        console.error('Could not find product size guide metafield template');
      }
    } catch (error) {
      console.error('Error loading size guide metafield content:', error);
    }
  }

  async loadPageContent(url) {
    try {
      if (this.pageContentContainer) {
        this.pageContentContainer.innerHTML = '';
      }

      if (this.pageTitleContainer) {
        this.pageTitleContainer.innerHTML = '';
      }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const pageTitle = doc.querySelector('.main-page-content [data-page-title]');

      if (pageTitle && this.pageTitleContainer) {
        this.pageTitleContainer.textContent = pageTitle.textContent;
      } else {
        console.error('Could not find page title or container');
      }

      const pageContent = doc.querySelector('.main-page-content');

      if (pageContent && this.pageContentContainer) {
        this.pageContentContainer.appendChild(pageContent);
      } else {
        console.error('Could not find page content or container');
      }
    } catch (error) {
      console.error('Error loading size guide content:', error);
    }
  }

  handleEditorEvents() {
    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        const sizeGuideLink = document.querySelector('product-details a[data-size-guide-link]');
        if (sizeGuideLink) {
          const href = sizeGuideLink.href;
          if (href) {
            if (href.includes('#size-guide-metafield-drawer')) {
              this.loadMetafieldContent();
            } else {
              this.loadPageContent(href);
            }
          }
        }
      });
    }
  }

  disconnectedCallback() {
    window.eventBus.off('open:size:guide', this.init);
    window.eventBus.off('close:size:guide', this.closeDrawer);
    super.disconnectedCallback();
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);
/******/ })()
;